import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import Login from './components/pages/Auth/Login';
import Register from './components/pages/Auth/Register';
import Home from './components/Home';
import Layout from './shared/Layout';
import LayoutReports from './shared/LayoutReports';
// import AllRequests from './components/AllRequests';
import Coletas from './components/Coletas';
import Gestao from './components/Gestao';
import MyRequests from "./components/MyRequests";
import Warehouse from './components/Warehouse';
import Profile from "./components/pages/User/Profile";
import Delivery from './components/Delivery';
import api from './utils/api';

// Context
// import { UserProvider } from "./context/UserContext";
// import { Context } from './context/UserContext'
import Feedbacks from './components/Feedbacks';
import ProtectedRoute from './utils/ProtectedRoute';
import Admin from './components/Admin';
import MyReverses from './components/MyReverses';
import ConsultaGerencialAtendimento from './components/reports/ConsultaGerencialAtendimento';
import ConsultaGerencialColetas from './components/reports/ConsultaGerencialColetas';
import Qualificacao from './components/reports/Qualificacao';
import RouteDelivery from './components/RouteDelivery';
import CodBloqueados from './components/CodBloqueados';
import UsersAdmin from './components/UsersAdmin';
// import Monitor from './components/Monitor';
import Monitor2 from './components/Monitor2';
import PowerBI from './components/PowerBI';
import Help from './components/Help';
import HomeEntregador from './components/HomeEntregador';
import Docs from './components/Docs';
import DocPage from './components/DocPage';
import PortalJustificativas from './components/PortalJustificativas';


function App() {
  

  const [loggedIn, setLoggedIn] = useState(false);
  const [token] = useState(localStorage.getItem("token") || "");

  useEffect(() => {
    async function fetchUser() {
      try {
        const response = await api.get("/users/checkuser", {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        });

        if (response.status === 200) {
          setLoggedIn(true);
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Token inválido ou expirado
          setLoggedIn(false);
          localStorage.removeItem("token"); // Remove o token inválido do localStorage
        } else {
          console.error("Erro ao verificar o usuário:", error);
        }
      }
    }

    if (token) {
      fetchUser();
    }
  }, [token]);



  return (
   
      <Routes>

      <Route path="/app" element={(loggedIn || token!== "") && <Layout />}>
        
        <Route path="" element={
             <ProtectedRoute setLoggedIn={setLoggedIn}>
                { loggedIn && <Home /> }
               </ProtectedRoute>
        } />

        {/* <Route path="requests" element={
            <ProtectedRoute loggedIn={loggedIn}>
              <AllRequests />
            </ProtectedRoute>
        } /> */}

        <Route path="monitor" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              { loggedIn && <Monitor2 setLoggedIn={setLoggedIn}/>}
            </ProtectedRoute>
        } />

        <Route path="report1" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <ConsultaGerencialAtendimento />
            </ProtectedRoute>
        } />

        <Route path="report2" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <ConsultaGerencialColetas />
            </ProtectedRoute>
        } />

        <Route path="qualificationreport" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Qualificacao />
            </ProtectedRoute>
        } />

        <Route path="warehouse" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Warehouse />
            </ProtectedRoute>
        } />

        <Route path="tosend" element={
             <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Delivery />
            </ProtectedRoute>
        } />

        <Route path="routedelivery" element={
             <ProtectedRoute setLoggedIn={setLoggedIn}>
              <RouteDelivery />
            </ProtectedRoute>
        } />

        <Route path="homeentregador" element={
             <ProtectedRoute setLoggedIn={setLoggedIn}>
              <HomeEntregador />
            </ProtectedRoute>
        } />

        <Route path="coletas" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Coletas />
              </ProtectedRoute>
        } />

        <Route path="gestao" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Gestao />
            </ProtectedRoute>
        } />

        <Route path="myrequests" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <MyRequests />
            </ProtectedRoute>
        } />

        <Route path="profile" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Profile />
            </ProtectedRoute>
        } />

        <Route path="feedbacks" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Feedbacks />
            </ProtectedRoute>
        } />

        <Route path="admin" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <Admin />
            </ProtectedRoute>
        } />

        <Route path="myreverses" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <MyReverses />
            </ProtectedRoute>
        } />

        <Route path="codbloqueados" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <CodBloqueados />
            </ProtectedRoute>
        } />

        <Route path="usersadmin" element={
            <ProtectedRoute setLoggedIn={setLoggedIn}>
              <UsersAdmin />
            </ProtectedRoute>
        } />

        <Route path="help" element={
          <ProtectedRoute setLoggedIn={setLoggedIn}>
            <Help />
          </ProtectedRoute>
        } />

        <Route path="justificativas" element={
          <ProtectedRoute setLoggedIn={setLoggedIn}>
            <PortalJustificativas />
          </ProtectedRoute>
        } />

        <Route path="docs" element={
          <ProtectedRoute setLoggedIn={setLoggedIn}>
            <Docs />
          </ProtectedRoute>
        } />

        <Route path="docs/:slug" element={
          <ProtectedRoute setLoggedIn={setLoggedIn}>
            <DocPage />
          </ProtectedRoute>
        } />

      </Route>

      <Route path="/app" element={<LayoutReports />}>

        <Route path="bireports" element={
          <ProtectedRoute setLoggedIn={setLoggedIn}>
            <PowerBI />
          </ProtectedRoute>
        } />
      </Route>

      <Route path="/login" element={<Login />} />

      <Route path="/register" element={<Register />} />

      <Route path="/" element={<Navigate replace to="/app" />} />
    </Routes>

      
  
  );
}

export default App;
